import ProviderAPI from "../redux/ProviderAPI";

export const getCompanyProfile = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/companyprofile/company",
    data,
    token,
  });
  return result;
};

export const getBranch = async (data, token) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/companyprofile/branch",
    data,
    token,
  });
  return result;
};

export const editCompany = async (data, token) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/companyprofile/editCompany",
    data,
    token,
  });
  return result;
};
